import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { Upload, UploadMenuItem } from '@xmedical/core';
import { UploadType } from '../../models/upload-type.type';
import { FolderComponent } from './folder/folder.component';

@Component({
  selector: 'xmed-files-folder-view',
  standalone: true,
  imports: [FolderComponent],
  templateUrl: './files-folder-view.component.html',
  styleUrl: './files-folder-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilesFolderViewComponent {
  uploads = input<Upload[]>([]);
  uploadType = input<UploadType>('practice');
  folders = input<UploadMenuItem[]>([]);
  maxFolderColumns = input<number>(4);
  patientId = input<number | null>(null);
  hasPatientDetails = input(false);
}
